export default {
  styleOverrides: {
    input: {
      padding: '3px 0 7px',
      lineHeight: '1.1876em',
      height: '1.1876em',
    },
  },
};
